import Vue from 'vue'
import VueRouter from 'vue-router'
import { authGuard } from "@/auth";
import store from '../store/store.js'
Vue.use(VueRouter)

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

const routes = [
  {
    path: "/",
    name: "Auth",
    component: loadView("Auth"),
    beforeEnter: (to, from, next) => {
      next('/loading')
    },
  },
  {
    path: "/bulk-upload-csv",
    name: "BulkUploadCSV",
    component: loadView("BulkUploadCSV"),
    beforeEnter: authGuard,
  },
  {
    path: "/bulk-upload-csv-v2",
    name: "BulkUploadCSV",
    component: loadView("BulkUploadCSV-v2"),
    beforeEnter: authGuard,
  },
  {
    path: "/import-charge-file",
    name: "ImportChargeFile",
    component: loadView("ImportChargeFile"),
    beforeEnter: authGuard,
  },
  {
    path: "/import-recurring-charge-file",
    name: "ImportRecurringChargeFile",
    component: loadView("ImportRecurringChargeFile"),
    beforeEnter: authGuard,
  },
  {
    path: "/import-wcg-charge-file",
    name: "ImportWcgCharge",
    component: loadView("ImportWcgCharge"),
    beforeEnter: authGuard,
  },
  {
    path: "/logs",
    name: "Logs",
    component: loadView("Logs"),
    beforeEnter: authGuard,
  },
  {
    path: "/loading",
    name: "loading",
    component: loadView("Loading"),
    beforeEnter: authGuard,
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router;
